import apiClient from 'services/axios'
import ApiConfig from 'services/config'

const { AuthConfig, PartnerConfig } = ApiConfig

export const formatUserResponse = response => {
  const { _id: id } = response.user
  const payload = {
    id,
    role: response.user.role,
    name: response.user.first_name.concat(' '.concat(response.user.last_name ?? '')).trim(),
    first_name: response.user.first_name,
    last_name: response.user.last_name,
    email: response.user.email,
  }
  if (response?.business) {
    payload.business = response?.business ?? {}
  }
  if (response?.franchise) {
    payload.franchise = response?.franchise ?? {}
  }
  if (response?.subscription) {
    payload.subscription = response?.subscription ?? {}
  }
  const franchise = response?.franchise
  const business_user = response?.business_user
  const business = business_user?.business
  const user_permission = business_user?.permission
  const franchise_business =
    franchise && franchise.businesses.find(o => o.business_id === business?._id)
  payload.is_main_business = !franchise || franchise?.main_business_id === business?._id
  payload.permission = {
    allow_enroll: !franchise_business || franchise_business.permission?.allow_enroll,
    allow_issue_gift: !franchise_business || franchise_business.permission?.allow_issue_gift,
    allow_manage_inbox:
      payload.subscription?.primary_billing_method === 'Stripe' &&
      payload.subscription?.stripe?.products?.find(o => o.name === 'Smart Inbox') != null,
    allow_manage_billing:
      !franchise_business || franchise_business.permission?.allow_manage_billing,
    allow_manage_users: !franchise_business || franchise_business.permission?.allow_manage_users,
    allow_manage_points: !franchise_business || franchise_business.permission?.allow_manage_points,
    allow_manage_sales: franchise_business?.permission?.allow_manage_sales,
    allow_manage_allowance: franchise_business?.permission?.allow_manage_allowance,
  }
  payload.user_permission = user_permission
  return payload
}

export async function getUserDetails() {
  return apiClient.get(AuthConfig.USER_DETAIL).then(res => {
    const response = res.data
    if (response) {
      return formatUserResponse(response)
    }
    return false
  })
}

export async function getPartners(code) {
  return apiClient.get(`${PartnerConfig.Partner}${code}`).then(response => response?.data)
}

export async function logout() {
  return apiClient.delete(AuthConfig.LOGOUT).then(response => response?.data)
}

export async function postPlan(code, data) {
  return apiClient({
    url: `${ApiConfig.AuthConfig.PLANS}${code}`,
    method: 'POST',
    data,
  }).then(response => {
    return response?.data?.business ?? {}
  })
}
